import React from 'react';

const SvgPrivateGuided = props => /*#__PURE__*/React.createElement("svg", Object.assign({
  viewBox: "0 0 100 100"
}, props), /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(8 13)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#EDEFF0",
  d: "M12.69 69.248H9.13a1.189 1.189 0 01-1.188-1.189V52.752a1.19 1.19 0 011.189-1.189h55.448a3.566 3.566 0 013.566 3.567v7.863h2.432v6.255h-4.25"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#53DD7D",
  d: "M10.32 48.49l.051-5.7a8.618 8.618 0 018.613-8.54 8.53 8.53 0 018.535 8.531v5.709"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#B9BBBF",
  stroke: "#3F4144",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M4.064 52.197H.534v10.479h3.53"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#3F4144",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M9.124 66.87H4.376V47.998h56.637a3.566 3.566 0 013.566 3.566v9.053h2.432v6.255h-4.25"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  stroke: "#3F4144",
  strokeLinejoin: "bevel",
  strokeWidth: 2,
  d: "M24.627 25.637c0 3.954-.077 5.483-.927 8.449-.693 2.417-4.264 5.144-6.191 5.144-1.361 0-4.929-1.497-6.213-5.144-.563-1.6-.952-4.417-1.168-8.45"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#3F4144",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "M16.281 34.274h2.748"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#B9BBBF",
  stroke: "#3F4144",
  strokeLinejoin: "bevel",
  strokeWidth: 2,
  d: "M24.948 21.508c-1.061-4.224-3.769-7.243-7.138-7.243-3.277 0-6.234 3.2-7.362 7.243"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#B9BBBF",
  stroke: "#3F4144",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M30.971 25.637H3.784l6.664-4.24h14.5z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#3F4144",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "M24.081 34.67c2.007 2.053 3.01 4.465 3.01 7.237v5.451M10.85 34.67c-2.464 2.007-3.696 4.413-3.696 7.216v5.472"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 15.112,
  cy: 29.715,
  r: 1.359,
  fill: "#3F4144"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 20.549,
  cy: 29.715,
  r: 1.359,
  fill: "#3F4144"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 17.81,
  cy: 14.265,
  r: 2.377,
  fill: "#3F4144"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(54.248)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 18.825,
  cy: 18.387,
  r: 7.132,
  fill: "#53DD7D"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 16.447,
  cy: 16.01,
  r: 7.132,
  stroke: "#3F4144",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#3F4144",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M16.088 4.122V0M22.508 6.005l2.245-3.457M26.906 11.084l3.737-1.742M27.854 17.707l4.083.574M25.072 23.793l3.111 2.704M19.448 27.413l1.136 3.963M12.728 27.413l-1.136 3.963M7.102 23.792l-3.11 2.704M4.322 17.707l-4.083.574M5.27 11.084L1.533 9.342M9.668 6.005L7.423 2.548"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#B9BBBF",
  stroke: "#3F4144",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M4.441 52.197H.912v10.479h3.529"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#EDEFF0",
  d: "M13.067 69.248H9.508A1.189 1.189 0 018.32 68.06V52.752a1.19 1.19 0 011.19-1.189h55.448a3.566 3.566 0 013.566 3.567v7.863h2.432v6.255h-4.25"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#3F4144",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M9.501 66.87H4.753V47.998H61.39a3.566 3.566 0 013.567 3.566v9.053h2.431v6.255H63.14M32.625 52.446h3.752M50.047 47.539l-4.99-10.527a4.822 4.822 0 00-4.357-2.757h-9.73v13.188"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 19.8,
  cy: 66.92,
  r: 6.254,
  fill: "#FFF",
  stroke: "#3F4144",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("circle", {
  cx: 56.111,
  cy: 66.92,
  r: 6.254,
  fill: "#FFF",
  stroke: "#3F4144",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("circle", {
  cx: 56.111,
  cy: 66.92,
  r: 2.502,
  fill: "#3F4144"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 19.835,
  cy: 66.92,
  r: 2.502,
  fill: "#3F4144"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#3F4144",
  strokeLinecap: "square",
  strokeWidth: 2,
  d: "M49.328 66.87H26.326"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#3F4144",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M42.367 29.266H30.851M39.433 30.361v3.365M34.07 30.339v3.365"
})), /*#__PURE__*/React.createElement("path", {
  stroke: "#3F4144",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M93.269 86.834H5.189"
})));

export default SvgPrivateGuided;